import { useContext, useEffect, useState } from 'react'
import { useMonitoringPeriodContext } from '../context/monitoringPeriodContext'
import AppContext from '../context/appContext'
import { userRoles } from '../utils/userRoles'

export const useUserRole = () => {
  const { userRoleSelected } = useContext(AppContext)
  const { hasBlockedMonitoringPeriods } = useMonitoringPeriodContext()
  const [isViewOnly, setIsViewOnly] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false)
  const [isGISTechnician, setIsGISTechnician] = useState(false)
  const [isAuditor, setIsAuditor] = useState(false)
  const [isFieldTechnician, setIsFieldTechnician] = useState(false)

  useEffect(() => {
    setIsViewOnly(userRoleSelected === userRoles.Analyst)
    setIsAdmin(userRoleSelected === userRoles.Admin)
    setIsAuditor(userRoleSelected === userRoles.Auditor)
    setIsFieldTechnician(userRoleSelected === userRoles.FieldTechnician)

    const gISTechnicianSelected = userRoleSelected === userRoles.GISTechnician
    if (gISTechnicianSelected) {
      // A GIS Technician is a view only user with access to edit geometries.
      setIsViewOnly(true)
      setIsGISTechnician(!hasBlockedMonitoringPeriods)
    } else {
      setIsGISTechnician(false)
    }
  }, [userRoleSelected, hasBlockedMonitoringPeriods])

  return { isViewOnly, isAdmin, isGISTechnician, isAuditor, isFieldTechnician }
}
